import { c as _c } from "react/compiler-runtime";
import VideoWalkthroughCard from '@src/components/sco/InvestorMatching/InvestorMatchingLanding/VideoWalkthroughCard';
import { ContentSection } from '@src/components/sco/LayoutBlocks/ContentSection';
import React from 'react';
export const TrackEmailContent = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <VideoWalkthroughCard url="/assets/videos/investor-match/activity-replies.mp4" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ContentSection component={t0} componentPlacement="left" description={"We\u2019ll provide a report of which emails were sent, who opened them, and who still needs to be followed up with so you can be completely on top of your fundraising campaign."} title="Track Every Investor Email" buttons={[{
      title: "Start Sending Pitches",
      href: "/investors/matching/start",
      variant: "cta"
    }]} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};